<template>
    <div class="beian flex2">
        <span class="ba_p1">四川剑南春(集团)有限责任公司</span>
        <span class="ba_p2">&nbsp;&nbsp;All&nbsp;Rights&nbsp;Reserved&nbsp;&nbsp;</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">
            <span class="ba_p3"> 蜀ICP备05018250号-1</span>
        </a>
        <img src="@/images/zf.png">
        <span>川公网安备</span>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51068302000111">
            <span class="ba_p4">51068302000111号</span>
        </a>
    </div>
</template>

<script>
export default {
    name:'record',
};
</script>

<style lang="scss">
    .beian{
        span{
            color: #999;
            cursor: pointer;
            font-size: 12px;
        }
        a{
            &:hover{
                text-decoration: none;
            }
        }
        .ba_p3,.ba_p4{
            &:hover{
                color: #f77667;
            }
        }
        img{
            width: 14px;
            height: 14px;
            margin: 0 5px;
        }
    }
</style>